"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CxfEvents = void 0;
var CxfEvents;
(function (CxfEvents) {
    CxfEvents["Token"] = "cxf.token";
    CxfEvents["Login"] = "cxf.login";
    CxfEvents["Signup"] = "cxf.signup";
    CxfEvents["GameEventUpdate"] = "cxf.gameEvent.update";
    CxfEvents["GameEventAdd"] = "cxf.gameEvent.add";
    CxfEvents["GameEventRemove"] = "cxf.gameEvent.remove";
    CxfEvents["XpChanged"] = "cxf.xp.changed";
    CxfEvents["LevelChanged"] = "cxf.level.changed";
    CxfEvents["LegendLevelChanged"] = "cxf.legendLevel.changed";
    CxfEvents["Push"] = "cxf.push";
    CxfEvents["OpenIGS"] = "cxf.igs.open";
    CxfEvents["JoinTempServer"] = "cxf.join.temp.server";
    CxfEvents["Subscription"] = "cxf.subscription";
    CxfEvents["RewardedAdStart"] = "cxf.rewardedad.start";
    CxfEvents["RewardedAdDone"] = "cxf.rewardedad.done";
})(CxfEvents = exports.CxfEvents || (exports.CxfEvents = {}));
